<template>
	<div class="w1">
	<div  class="Main_wrapper"><!-- Main_wrapper -->
		<ul class="title1">
			<li class="L">政府公报</li>
			<li class="R"></li>
		</ul>
		<itemsearch @showzixunjianyifromsearch="showfankui" v-bind:colid='colid' v-bind:colname='colname' v-bind:colfrom="'gongbao'" @searchshow="searchshow" @searchclose="searchclose"></itemsearch>
	
		<div v-show="!searchResultShow" class="group2c"><!-- group2c -->
			<div class="group2c_L"><!-- group2c_L -->
			
				<div class="report_nav_wrap sticky1"><!-- report_nav_wrap -->
					<div class="report_nav"><!-- report_nav -->
						<dl>
							<!-- <dt>政府公报</dt> -->
							<dd v-for="(item,index) in subcolumList" >
								<!-- <a @click="searchClick(item.columnid)" :class="[item.columnid==searchColum?'on':'']" style="cursor: pointer;">{{item.columnnamethird}}</a> -->
								<router-link :to="{ name: 'gongbao', params: { column: item.columnname }}" :class="[item.columnid==searchColum?'on':'']" style="cursor: pointer;">{{item.columnname}}</router-link>
							</dd>
						</dl>
						<!-- <dl>
							<dt><a href="">产业发展</a></dt>
						</dl>
						<dl>
							<dt><a href="">经济改革</a></dt>
						</dl>
						<dl>
							<dt><a href="">政策追踪</a></dt>
						</dl> -->
					
					</div><!-- /report_nav -->
				</div><!-- /report_nav_wrap -->
				
				
		
			</div><!-- /group2c_L -->
			<div class="group2c_M"><!-- group2c_M -->				
			
				<div class="Tabnav_box"><!-- Tabnav_box -->
						<div class="Tabnav_box_L">
						</div>
						<div class="Tabnav_box_R2">
						
							<div id="areaPanelDiv" class="Tabnav_out" name="Tabnav_out" @click="showAreaPanel()" :class="searchColum=='3ac8917d0c694ede818c474f0da4155a'?'PanelDisable':''" ><!-- Tabnav_out -->
								<div class="Tabnav_screen2" name="Tabnav_screen">{{searchColum=='3ac8917d0c694ede818c474f0da4155a'?'全国':searchAreaText}}</div>
								<el-collapse-transition>
									<div class="Tabnav2"  name="Tabnav"  style="right: 0;" v-show="areaPanelVisible">
										<dl v-for="(item,index) in Object.keys(areaList)">
											<dt>{{item}}</dt>
											<dd>
												<a v-for="(subitem,subindex) in areaList[item]" 
												@click.stop="areaClick(subitem.areacode,subitem.areaname)" 
												:class="searchArea==subitem.areacode?'on':''">{{subitem.areaname}}</a>
											</dd>
										</dl>
									</div>
								</el-collapse-transition>
							</div><!-- /Tabnav_out -->
				
						</div>
				</div><!-- /Tabnav_box -->	
	
				<el-skeleton :rows="15" :loading="loadingMask" animated :throttle="500">
	
				<ul v-if="totalResultCount" class="zjpl_list" style="min-height: 516px;" ><!-- zjpl_list -->
					<li v-for="(result,index) in resultDataList" :key="result.id" >
						<dl>
							<dt>
								<L v-if="searchColum=='3c8ec947b301425287b89b7d230accd3'">
									<a @click="jumppush('/detail/'+result.id+'/1?col=gongbao')" class="T-tit" target="_blank" v-html="result.title"></a>
								</L>
								<L v-else>
									<a @click="jumppush('/detail/'+result.id+'?col=gongbao')" class="T-tit" target="_blank" v-html="result.title"></a>
								</L>
								<R>{{result.publishtime?result.publishtime.substring(0,10):''}}</R>
							</dt>
						</dl>
					</li>
				</ul><!-- /zjpl_list -->
				<div v-else-if="!loadingMask" class="search_none" style="min-height: 516px;">
					<h5>暂无数据</h5>
				</div>
				<div v-else class="search_none" style="min-height: 516px;">
					<h5>读取中......</h5>
				</div>
	
	
	
				<div class="m_b1"></div>
	
	
				<el-row class="pagediv">
					<el-pagination
								@size-change="changePageSize"
								@current-change="changeSearchPage"
								:current-page="pageNum"
								:page-sizes="[10, 15, 20]"
								:page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="totalResultCount"
								:hide-on-single-page="!totalResultCount">
							</el-pagination>
				</el-row>
		
		
				</el-skeleton>
		
			</div><!-- /group2c_M -->
		</div><!-- /group2c -->
	
		
		
	
	</div><!-- /Main_wrapper -->
	</div>
</template>

<script>
	import itemsearch from '@/components/list-item-search.vue'
	export default {
		data() {
			return {
				hasPower:true,
				loadingMask: true,
				colid:'4d8d655b07414efcadb75ab9e630f20a',
				colname:'公报',
				searchColum: '',
				keyword: '',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
				subcolumList:[],
				searchArea:'',
				searchAreaText:'全部地区',
				areaList:{'默认':[{areacode:'',areaname:'全部地区'}]},
				areaPanelVisible:false,
				searchResultShow:false,
			}
		},
		components:{
			itemsearch,
		},
		mounted:function(){
			document.title='公报-中经专网';
			// this.searchArea=this.$cookies.get('GBSearchArea')?this.$cookies.get('GBSearchArea'):'';
			// this.searchAreaText=this.$cookies.get('GBSearchAreaText')?this.$cookies.get('GBSearchAreaText'):'全部地区';
			this.subcolumfnc();
			this.areafnc();
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		watch: {
			$route (to, from) {
				if(to.params.column != from.params.column){
					this.searchArea='';
					this.searchAreaText='全部地区';
					if(this.subcolumList.length>0){
						if(this.$route.params.column){
							for(var i=0;i<this.subcolumList.length;i++){
								if(this.subcolumList[i].columnname==this.$route.params.column){
									this.searchClick(this.subcolumList[i].columnid);
									break;
								}
							}
						}
						else{
							this.searchClick(this.subcolumList[0].columnid);
						}
					}
				}
			}
		},
		methods: {
			authcheck:function(){
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').indexOf('gongbao')>-1){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			jumppush:function(to){
				this.authcheck();
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			showAreaPanel:function(){
				this.areaPanelVisible=true;
				let _this = this;
				var listenerfunc=function(e){
					if(!document.getElementById('areaPanelDiv').contains(e.target)){
						_this.areaPanelVisible=false;
						document.removeEventListener('click',listenerfunc);
					}
				}
				document.addEventListener('click',listenerfunc)
			},
			areafnc:function(){
				let _this = this;
				this.$http({
						method: 'get',
						url: 'column/selectAttributeInfoByparentID',
						responseType: 'json',
						params: {
							parentID: '0fe5d7a5ada54576a3492bf33a16e4c4',
						},
					})
					.then(function(response) {
						_this.areaList=Object.assign(_this.areaList,response.data.data.data);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			areaClick:function(value,name){
				this.searchArea=value;
				this.searchAreaText=name;
				// this.$cookies.set('GBSearchArea',this.searchArea);
				// this.$cookies.set('GBSearchAreaText',this.searchAreaText);
				this.$track([
					['pagetype','公报地区筛选'],
					['reqtype','2'],
					['column',this.searchColum],
					['searchkeyword',this.searchArea],
				]);
				this.searchClick(this.searchColum);
				this.areaPanelVisible=false;
			},
			subcolumfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'column/selectAllByparentID',
						responseType: 'json',
						params: {
							parentID: this.colid,
							attribute: 0,
						},
					})
					.then(function(response) {
						_this.subcolumList=response.data.data.data;
						_this.searchArea='';
						_this.searchAreaText='全部地区';
						if(_this.subcolumList.length>0){
							if(_this.$route.params.column){
								for(var i=0;i<_this.subcolumList.length;i++){
									if(_this.subcolumList[i].columnname==_this.$route.params.column){
										_this.searchClick(_this.subcolumList[i].columnid);
										break;
									}
								}
							}
							else{
								_this.searchClick(_this.subcolumList[0].columnid);
							}
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			searchClick: function(columnid) {
				if (columnid) {
					this.searchColum=columnid;
					this.$track([
						['pagetype','公报列表'],
						['reqtype','2'],
						['column',this.searchColum]
					]);
				}
				this.pageNum = 1;
				this.pageSize= 10;
				this.searchfnc();
			},
			searchfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'article/searchArticles',
						responseType: 'json',
						params: {
							columnID:this.searchColum,
							areacode:this.searchColum=='3ac8917d0c694ede818c474f0da4155a'?'':this.searchArea,
							iPage: this.pageNum,
							pageSize: this.pageSize,
							orderBy:'publishtime',
							isDesc:'1',
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});;
			},
			changePageSize:function(pagesize){
				this.pageSize=pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.searchfnc();
			},
			searchColumChange: function(index,indexPath) {
				// console.log(index);
				this.searchColum=index;
				this.pageNum = 1;
				this.pageSize= 10;
				this.searchfnc();
			},
			searchshow:function(key){
				this.searchResultShow=true;
			},
			searchclose:function(){
				this.searchResultShow=false;
			},
			showfankui:function(){
				this.$emit('showzixunjianyifromsearch');
			}
		}
	}
</script>

<style>

</style>
